import { Component, computed, HostListener, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TopBarComponent } from "../top-bar/top-bar.component";
import { NgClass } from '@angular/common';

@Component({
  selector: 'usar-primary-layout',
  imports: [RouterOutlet, TopBarComponent, NgClass],
  templateUrl: './primary-layout.component.html',
  styleUrl: './primary-layout.component.scss'
})
export class PrimaryLayoutComponent {

  public innerWidth: any;
  public cssClass$ = computed(()=>{return this.cssClass()});

  public get isMobileView(){
    try {
      return (Number(this.innerWidth)<=768);

    }
    catch (e){
      return false;
    }
  }

  ngOnInit() {
      this.innerWidth = window.innerWidth;
  }
  
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  cssClass(){
    let retVal = !this.isMobileView?"":"d-flex flex-row";
    return retVal;
  }

}
